import React from 'react'
import {grid, gridItem} from '~/design-system/foundations'
import {cn} from '~/design-system/utils'
import {hgComposableDetailsSection} from './variants'

export type HgComposableDetailsSectionProps = {
  title: string | React.ReactNode
  children: React.ReactNode
  className?: string
  fullWidth?: boolean
}

const HgComposableDetailsSection: React.FC<HgComposableDetailsSectionProps> = ({
  title,
  children,
  className,
  fullWidth,
}) => {
  const {title: titleVariant, body} = hgComposableDetailsSection({fullWidth})

  const size = fullWidth ? undefined : 'max'

  return (
    <div className={cn('w-full pt-s9', className)}>
      <div className={grid({className: 'mx-auto'})}>
        <div
          className={gridItem({
            size,
            className:
              'grid grid-cols-1 gap-s6 border-t border-border-subdued pt-s4 lg:grid-cols-12',
          })}
        >
          <h2 className={titleVariant()}>{title}</h2>
          <div className={body()}>{children}</div>
        </div>
      </div>
    </div>
  )
}

export default HgComposableDetailsSection
